import { useEffect, useState } from 'react';

export interface ViewportSize {
  width: number;
  height: number;
}

export function useViewportSize(): ViewportSize {
  const [size, setSize] = useState<ViewportSize>(() => (
    typeof window === 'undefined'
      ? { width: 1280, height: 720 }
      : { width: window.innerWidth, height: window.innerHeight }
  ));

  useEffect(() => {
    const onResize = () => setSize({ width: window.innerWidth, height: window.innerHeight });
    window.addEventListener('resize', onResize);
    return () => window.removeEventListener('resize', onResize);
  }, []);

  return size;
}

/**
 * Tracks window.innerWidth for responsive layout decisions (mobile drawer,
 * camera framing, etc.). Presentation-only concern, not physics state.
 */
export function useViewportWidth(): number {
  return useViewportSize().width;
}
